<shared-components-breadcrumbs></shared-components-breadcrumbs>

<div class="fill-base hmf-subtle-shadow hmf-sharp-radius hmf-p-m" data-testid="order-details-table" *ngIf="orderDetail">
	<div class="col-md-12 col-xl-12 mx-auto">
		<my-account-order-track-components-order-detail-cards [orderDetail]="orderDetail"></my-account-order-track-components-order-detail-cards>
		<div *ngIf="showDSRecommendationsOD" class="hmf-pt-l">
			<product-recommendations-components-ds-product-recommendations
			[placementID]="'frequently-bought-together-high-diversity'"
			[displayName]="'You May also like'"
			[priceRerankLevel]="'high-price-reranking'"
			[eCodeList]="eCodeList"
			[pageType]="'OrderDetails'">
			</product-recommendations-components-ds-product-recommendations>
		</div>
	</div>
</div>
